export enum ObservationTypeValues {
    Invalid = 0,
    Differentiated = 28,
    Formal = 29,
    Rubric = 30,
    Walkthrough = 31,
    Anecdotal = 32,
    SLO = 33,
    PrincipalSLO = 34,
    NTPE = 111,
    X82 = 112,
    CustomForm = 117,
    PerformanceGoal = 128,
    IEP = 129,
    SPM = 130
}
